import { Route, Routes } from 'react-router-dom'
import { PasswordChangeForceLayout } from 'pages/auth/pages/passwordChangeForce/layout/PasswordChangeForceLayout'
import { PasswordChangeForcePage } from 'pages/auth/pages/passwordChangeForce/ui/passwordChangeForcePage'

export const PasswordChangeForceRouter = () => {
  return (
    <Routes>
      <Route element={<PasswordChangeForceLayout />}>
        <Route path={'/'} element={<PasswordChangeForcePage />} />
      </Route>
    </Routes>
  )
}
